import { Icon } from '@iconify/react';

interface FilePreviewProps {
  file: File;
}

export const FilePreview: React.FC<FilePreviewProps> = ({ file }) => {
  return (
    <div className='bg-default-100 p-4 rounded-lg flex items-center gap-4'>
      <Icon
        icon='tabler:file-spreadsheet'
        width={30}
        className='text-green-500'
      />
      <div>
        <p className='font-semibold'>{file.name}</p>
        <p className='text-sm text-default-400'>
          {(file.size / 1024 / 1024).toFixed(2)} MB
        </p>
      </div>
    </div>
  );
};
